import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  FilterProps,
  PagedResponse,
} from '../../core/store/general/models/general';
import { ILibraryData,Library } from '../../core/store/risks/models/Library';
import {
  IRiskAsset,
  IRiskCompliance,
  RiskEdit,
  Risks,
  RisksFromVulnerability,
  RisksTasks,
} from '../../core/store/risks/models/Risks';
import { createParams } from '../../core/store/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class RisksService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getRisksRegister(props: FilterProps): Observable<PagedResponse<Risks>> {
    return this.http.get<PagedResponse<Risks>>(
      `${this.baseApiUrl}/risks${createParams(props)}`,
    );
  }

  getRisksRegisterById(riskId: string): Observable<Risks> {
    return this.http.get<Risks>(`${this.baseApiUrl}/risks/${riskId}`);
  }

  getRisksVulnerabilityById(
    id: string,
    props: FilterProps,
  ): Observable<PagedResponse<RisksFromVulnerability>> {
    return this.http.get<PagedResponse<RisksFromVulnerability>>(
      `${this.baseApiUrl}/risks/vulnerabilities/${id}${createParams(props)}`,
    );
  }

  getRisksTasksById(
    id: string,
    props: FilterProps,
  ): Observable<PagedResponse<RisksTasks>> {
    return this.http.get<PagedResponse<RisksTasks>>(
      `${this.baseApiUrl}/risks/tasks/${id}${createParams(props)}`,
    );
  }

  getRisksAssetsById(
    id: string,
    props: FilterProps,
  ): Observable<PagedResponse<IRiskAsset>> {
    return this.http.get<PagedResponse<IRiskAsset>>(
      `${this.baseApiUrl}/risks/assets/${id}${createParams(props)}`,
    );
  }

  addRiskRegister(body: Risks): Observable<any> {
    return this.http.post(`${this.baseApiUrl}/risks/create`, body);
  }

  updateRiskRegister(
    riskId: string,
    newBody: Partial<RiskEdit>,
  ): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseApiUrl}/risks/update`, {
      riskId: riskId,
      ...newBody,
    });
  }

  deleteRiskRegister(riskId: string): Observable<string> {
    return this.http.delete<string>(`${this.baseApiUrl}/risks/${riskId}`);
  }

  getRisksLibrary(props: FilterProps): Observable<PagedResponse<Risks>> {
    return this.http.get<PagedResponse<Risks>>(
      `${this.baseApiUrl}/risks/library${createParams(props)}`,
    );
  }

  getRisksLibraryById(riskId: string): Observable<Library> {
    return this.http.get<Library>(`${this.baseApiUrl}/risks/library/${riskId}`);
  }

  getRisksLibraryData(
    props: FilterProps,
  ): Observable<PagedResponse<ILibraryData>> {
    return this.http.get<PagedResponse<ILibraryData>>(
      `${this.baseApiUrl}/risks/library/data${createParams(props)}`,
    );
  }

  getRisksComplianceById(riskId: string): Observable<IRiskCompliance> {
    return this.http.get<IRiskCompliance>(
      `${this.baseApiUrl}/risks/${riskId}/compliance`,
    );
  }
}
